import React, {useState} from 'react';
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import {useFeedbackTools} from "../../../../components/FeedbackTools";

import {useFilterRules} from "../useFilterRules";
import {RuleForm} from "../RuleForm";

import {CardLayout} from "./CardLayout";
import {CardBody} from "./CardBody";


const RuleCard = props => {
    const {
        initialRule = null,
        initialTemporalRules = [],
        attributes,
        avatarColor,
        AvatarIcon
    } = props;

    const {
        rule,
        temporalRules,
        addRule,
        addTemporalRule,
        deleteRule,
        deleteTemporalRule
    } = useFilterRules(initialRule, initialTemporalRules);

    let navigate = useNavigate();

    const [showForm, setShowForm] = useState(false);

    const {askConfirmation} = useFeedbackTools();

    const handleOpenForm = () => {
        setShowForm(true);
    };

    const handleCloseForm = () => {
        setShowForm(false);
    };

    const handleSave = async (rule, isTemporal) => {
        isTemporal ? await addTemporalRule(rule) : await addRule(rule);
        setShowForm(false);
    };

    const handleShowRequests = (ruleId) => {
        navigate(`filter-rules/${ruleId}/requests`);
    };

    const handleDelete = (id, isTemporal = false) => {
        askConfirmation({
            title: "Elimina Filtro",
            description: `Confermi l'eliminazione del filtro selezionato?`,
            confirmationText: 'Si',
            cancellationText: 'No',
            onConfirm: async () => isTemporal ? await deleteTemporalRule(id) : await deleteRule(id)
        });
    };

    return (
        <React.Fragment>
            <CardLayout avatarColor={avatarColor} AvatarIcon={AvatarIcon}>
                <CardBody rule={rule}
                          temporalRules={temporalRules}
                          attributes={attributes}
                          onShowRequests={handleShowRequests}
                          onCreate={handleOpenForm}
                          onDelete={handleDelete}/>
            </CardLayout>

            {showForm &&
            <RuleForm attributes={attributes}
                      hasRule={rule != null}
                      onClose={handleCloseForm}
                      onSave={handleSave}/>
            }
        </React.Fragment>
    );
};

RuleCard.propTypes = {
    initialRule: PropTypes.object,
    initialTemporalRules: PropTypes.arrayOf(PropTypes.object),
    attributes: PropTypes.object.isRequired,
    avatarColor: PropTypes.string.isRequired,
    AvatarIcon: PropTypes.object.isRequired,
};

export {RuleCard}